//service details backup
import { useState, useEffect, useCallback, Fragment } from "react";
import classes from "../servicedetails/ServiceDetails.module.css";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import ServiceTable from "./serviceTable";
import InputField from "../../../commoncomponents/input/InputField";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import { clinicDetailsObject } from "../servicemain/ServiceComponent";
import TimeComponent from "../../../commoncomponents/input/TimeComponent";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import { getDateFromHours } from "../../../../util/GenralUtils";
import Progress from "../../progressbar/RegistrationProgressBar";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import { getRequest, singoutHandler } from "../../../../api/AxiosAPICall";
import {
  Backdrop,
  Box,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  Stack,
  Tab,
  Tabs,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { FormikProvider, getIn } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Container sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Container>
      )}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const ServiceDetails = ({
  formik,
  mode,
  sendCliId,
  sendClinicData,
}: {
  formik: any;
  mode: any;
  sendCliId: any;
  sendClinicData: any;
}) => {
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [data, setData] = useState([]) as any;
  const [clinicIdForEdit, setClinicIdForEdit] = useState();
  const [disableRegister, setDisableRegister] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  let jwtToken: any;
  const dispatch = useDispatch();
  let history = useNavigate();

  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }

  useEffect(() => {
    setDisableButton(false);
    if (Object.values(data).length === 0) {
      setDisableRegister(true);
    }
  }, [data]);

  const fetchClinicData = useCallback(async () => {
    setOpen(true);
    const response = await getRequest("clinic", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      sendCliId(response?.data.cliId);
      formik.setFieldValue("clinicName", response?.data.cliName);
      formik.setFieldValue(
        "additionalServices",
        response?.data.cliAdditionalServices
      );
      let businessHours = response?.data?.businessHoursJson;
      if (
        businessHours?.cbhMondayStartTime !== null &&
        businessHours?.cbhMondayStartTime !== undefined &&
        businessHours?.cbhMondayStartTime !== ""
      ) {
        formik.setFieldValue(
          `monday[0].startTime`,
          getDateFromHours(businessHours.cbhMondayStartTime)
        );
      }

      if (
        businessHours?.cbhMondayEndTime !== null &&
        businessHours?.cbhMondayEndTime !== undefined &&
        businessHours?.cbhMondayEndTime !== ""
      ) {
        formik.setFieldValue(
          `monday[0].endTime`,
          getDateFromHours(businessHours.cbhMondayEndTime)
        );
      }

      if (
        businessHours?.cbhTuesdayStartTime !== null &&
        businessHours?.cbhTuesdayStartTime !== undefined &&
        businessHours?.cbhTuesdayStartTime !== ""
      ) {
        formik.setFieldValue(
          `tuesday[0].startTime`,

          getDateFromHours(businessHours.cbhTuesdayStartTime)
        );
      }

      if (
        businessHours?.cbhTuesdayEndTime !== null &&
        businessHours?.cbhTuesdayEndTime !== undefined &&
        businessHours?.cbhTuesdayEndTime !== ""
      ) {
        formik.setFieldValue(
          `tuesday[0].endTime`,

          getDateFromHours(businessHours.cbhTuesdayEndTime)
        );
      }

      if (
        businessHours?.cbhWednesdayStartTime !== null &&
        businessHours?.cbhWednesdayStartTime !== undefined &&
        businessHours?.cbhWednesdayStartTime !== ""
      ) {
        formik.setFieldValue(
          `wednesday[0].startTime`,
          getDateFromHours(businessHours.cbhWednesdayStartTime)
        );
      }

      if (
        businessHours?.cbhWednesdayEndTime !== null &&
        businessHours?.cbhWednesdayEndTime !== undefined &&
        businessHours?.cbhWednesdayEndTime !== ""
      ) {
        formik.setFieldValue(
          `wednesday[0].endTime`,

          getDateFromHours(businessHours.cbhWednesdayEndTime)
        );
      }

      if (
        businessHours?.cbhThursdayStartTime !== null &&
        businessHours?.cbhThursdayStartTime !== undefined &&
        businessHours?.cbhWednesdayEndTime !== ""
      ) {
        formik.setFieldValue(
          `thursday[0].startTime`,

          getDateFromHours(businessHours.cbhThursdayStartTime)
        );
      }

      if (
        businessHours?.cbhThursdayEndTime !== null &&
        businessHours?.cbhThursdayEndTime !== undefined &&
        businessHours?.cbhThursdayEndTime !== ""
      ) {
        formik.setFieldValue(
          `thursday[0].endTime`,

          getDateFromHours(businessHours.cbhThursdayEndTime)
        );
      }

      if (
        businessHours?.cbhFridayStartTime !== null &&
        businessHours?.cbhFridayStartTime !== undefined &&
        businessHours?.cbhFridayStartTime !== ""
      ) {
        formik.setFieldValue(
          `friday[0].startTime`,

          getDateFromHours(businessHours.cbhFridayStartTime)
        );
      }

      if (
        businessHours?.cbhFridayEndTime !== null &&
        businessHours?.cbhFridayEndTime !== undefined &&
        businessHours?.cbhFridayEndTime !== ""
      ) {
        formik.setFieldValue(
          `friday[0].endTime`,

          getDateFromHours(businessHours.cbhFridayEndTime)
        );
      }

      if (
        businessHours?.cbhSaturdayStartTime !== null &&
        businessHours?.cbhSaturdayStartTime !== undefined &&
        businessHours?.cbhSaturdayStartTime !== ""
      ) {
        formik.setFieldValue(
          `saturday[0].startTime`,

          getDateFromHours(businessHours.cbhSaturdayStartTime)
        );
      }

      if (
        businessHours?.cbhSaturdayEndTime !== null &&
        businessHours?.cbhSaturdayEndTime !== undefined &&
        businessHours?.cbhSaturdayEndTime !== ""
      ) {
        formik.setFieldValue(
          `saturday[0].endTime`,

          getDateFromHours(businessHours.cbhSaturdayEndTime)
        );
      }

      if (
        businessHours?.cbhSundayStartTime !== null &&
        businessHours?.cbhSundayStartTime !== undefined &&
        businessHours?.cbhSundayStartTime !== ""
      ) {
        formik.setFieldValue(
          `sunday[0].startTime`,

          getDateFromHours(businessHours.cbhSundayStartTime)
        );
      }

      if (
        businessHours?.cbhSundayEndTime !== null &&
        businessHours?.cbhSundayEndTime !== undefined &&
        businessHours?.cbhSundayEndTime !== ""
      ) {
        formik.setFieldValue(
          `sunday[0].endTime`,

          getDateFromHours(businessHours.cbhSundayEndTime)
        );
      }
    }
    setOpen(false);
    // eslint-disable-next-line
  }, [sendCliId, dispatch, mode, jwtToken, history, formik]);
  useEffect(() => {
    if (mode === "edit") {
      fetchClinicData();
    }

    //eslint-disable-next-line
  }, [mode]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  //This function used for set Start time and End time values for other tabs
  const SetTimeForWeekTab = (
    formik: any,
    value: any,
    weekIndex: any,
    day: number
  ) => {
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    days.splice(day, 1);
    days.forEach((element) => {
      formik.setFieldValue(
        `${element}[${weekIndex}].startTime`,
        value.startTime
      );
      formik.setFieldValue(`${element}[${weekIndex}].endTime`, value.endTime);
    });
  };

  //This function used for set Start time and End time values for All when we click on edit
  const SetTimeForAll = (formik: any, value: any, weekIndex: any) => {
    setValue(0);
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    days.forEach((element: string) => {
      formik.setFieldValue(
        `${element}[${0}].startTime`,
        value[element][0]?.startTime
      );
      formik.setFieldValue(
        `${element}[${0}].endTime`,
        value[element][0]?.endTime
      );
    });
  };

  //This function used for reset all form
  const ResetAllField = (formik: any) => {
    formik.setFieldValue("clinicName", "");
    formik.setFieldValue("additionalServices", "");
    formik.setFieldValue("monday[0].setTimeAllWeek", false);
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    days.forEach((element: string) => {
      formik.setFieldValue(`${element}[${0}].startTime`, null);
      formik.setFieldValue(`${element}[${0}].endTime`, null);
    });
  };

  //This Style is for Business hours Timings active tabs
  const styles = {
    tabClass: {
      backgroundColor: "#6E6E6E !important",
      color: "#ffffff !important",
      minWidth: "14.3%",
      "&.Mui-selected": {
        backgroundColor: "#006699 !important",
      },
    },
  };

  const handleEdit = async (data: any, index: any) => {
    setClinicIdForEdit(data.clinicId);
    window.scrollTo(0, 0);
    setIsUpdate(true);
    formik.setFieldValue("clinicName", data.clinicName);
    formik.setFieldValue("additionalServices", data.additionalServices);
    SetTimeForAll(formik, data, index);
  };

  const handleUpdate = (data: any, formik: any) => {
    const index = data.findIndex((object: any) => {
      return object.clinicId === clinicIdForEdit;
    });

    if (index !== -1) {
      data[index].clinicId = clinicIdForEdit;
      data[index].clinicName = formik.clinicName;
      data[index].additionalServices = formik.additionalServices;
      data[index].monday = [
        {
          startTime: formik.monday[0].startTime,
          endTime: formik.monday[0].endTime,
          setTimeAllWeek: formik.monday[0].setTimeAllWeek,
        },
      ];
      data[index].tuesday = [
        {
          startTime: formik.tuesday[0].startTime,
          endTime: formik.tuesday[0].endTime,
        },
      ];
      data[index].wednesday = [
        {
          startTime: formik.wednesday[0].startTime,
          endTime: formik.wednesday[0].endTime,
        },
      ];
      data[index].thursday = [
        {
          startTime: formik.thursday[0].startTime,
          endTime: formik.thursday[0].endTime,
        },
      ];
      data[index].friday = [
        {
          startTime: formik.friday[0].startTime,
          endTime: formik.friday[0].endTime,
        },
      ];
      data[index].saturday = [
        {
          startTime: formik.saturday[0].startTime,
          endTime: formik.saturday[0].endTime,
        },
      ];
      data[index].sunday = [
        {
          startTime: formik.sunday[0].startTime,
          endTime: formik.sunday[0].endTime,
        },
      ];
    }
  };

  const handleDelete = (event: any, removeIndex: any) => {
    formik.setFieldValue("district", null);
    ResetAllField(formik);
    setIsUpdate(false);
    setData((oldArray: any) => {
      return oldArray.filter((value: any, index: any) => index !== removeIndex);
    });

    dispatch(
      setSnackbar(
        true,
        2000,
        "success",
        "Clinic Deleted Sucessfully!",
        "top",
        "center"
      )
    );
  };

  const addService = () => {
    if (Object.keys(formik.errors).length !== 0) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Please fill all required fields!",
          "top",
          "center"
        )
      );
    }
    if (
      Object.keys(formik.errors).length === 0 &&
      Object.keys(formik.touched).length !== 0
    ) {
      setDisableButton(true);
    }
    setTimeout(() => {
      formik.setTouched({
        clinicName: true,
      });

      const isFound = data?.some((element: any) => {
        if (
          formik?.values?.clinicName?.toUpperCase() ===
          element?.clinicName?.toUpperCase()
        ) {
          return true;
        }
        return false;
      });

      if (isFound) {
        setOpen(false);
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cannot have two clinic with similar name, Please enter unique clinic name.",
            "top",
            "center"
          )
        );
      }
      if (
        Object.keys(formik.errors).length === 0 &&
        Object.keys(formik.touched).length !== 0 &&
        !isFound &&
        formik.values.clinicName !== undefined &&
        formik.values.clinicName !== "" &&
        formik.values.clinicName !== null
      ) {
        data.push(formik.values);
        ResetAllField(formik);
        formik.setFieldValue("clinicId", +formik?.values?.clinicId + 1);
        dispatch(
          setSnackbar(
            true,
            3000,
            "success",
            "Clinic Added Sucessfully!",
            "top",
            "center"
          )
        );
        formik.setTouched({
          clinicName: false,
        });
        setDisableRegister(false);
      }
      setDisableButton(false);
    }, 500);
  };

  const updateService = () => {
    if (Object.keys(formik.errors).length !== 0 && !formik?.values.clinicName) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Please fill all required fields!",
          "top",
          "center"
        )
      );
    }
    if (
      Object.keys(formik.errors).length === 0 &&
      Object.keys(formik.touched).length !== 0
    ) {
      setDisableButton(true);
    }

    const isIdFound = data?.some((element: any) => {
      if (
        formik?.values?.clinicName?.toUpperCase() ===
          element?.clinicName?.toUpperCase() &&
        clinicIdForEdit !== element?.clinicId
      ) {
        return true;
      }
      return false;
    });
    if (isIdFound) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cannot have two clinic with similar name, Please enter unique clinic name.",
          "top",
          "center"
        )
      );
      setDisableButton(false);
    }

    setTimeout(() => {
      if (
        Object.keys(formik.errors).length === 0 &&
        Object.keys(formik.touched).length !== 0 &&
        !isIdFound
      ) {
        setIsUpdate(false);
        ResetAllField(formik);
        handleUpdate(data, formik.values);
        dispatch(
          setSnackbar(
            true,
            3000,
            "success",
            "Clinic information updated sucessfully!",
            "top",
            "center"
          )
        );
      }
      formik.setTouched({
        clinicName: false,
      });
      setDisableButton(false);
    }, 500);
  };

  return (
    <Fragment>
      {/* Clinic Information code*/}
      {mode !== "edit" && <Progress activeStep={1} />}
      <FormikProvider value={formik}>
        <Box>
          <CommonCard>
            <Grid container>
              <Grid item md={12}>
                <Typography variant="h1" className={globalClasses.typography}>
                  Clinic Information
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              className={classes.rowSpace}
              direction="row"
              sx={{ marginBottom: "20px" }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={5.5}
                className={classes.formControlZeroMarginTop}
              >
                <input
                  type="hidden"
                  id="clinicId"
                  name="clinicId"
                  value={formik.values.clinicId ?? ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <InputField
                  id="clinicName"
                  name="clinicName"
                  label="Clinic Name"
                  inputvalues={formik.values.clinicName}
                  changeevent={(event: any) => {
                    formik.handleChange(event);
                  }}
                  blurevent={(event: any) => {
                    formik.handleBlur(event);
                  }}
                  errormessage={
                    formik.touched.clinicName &&
                    Boolean(formik.errors.clinicName)
                  }
                  message={
                    formik.touched.clinicName && formik.errors.clinicName
                  }
                  readOnly={mode === "edit" ? true : false}
                  disable={mode === "edit" ? true : false}
                  placeholder="e.g: The name you would like your practice to be referred as"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={12}>
                <Stack alignItems="left">
                  <TextField
                    id="additionalServices"
                    name="additionalServices"
                    value={formik.values.additionalServices}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    aria-label="Additional services"
                    label="Additional services"
                    placeholder="e.g. Blood test, X-Ray, Pregnancy test, Swab test"
                    sx={{ maxWidth: "500px" }}
                    helperText={
                      formik.touched.additionalServices &&
                      formik.errors.additionalServices
                    }
                    error={
                      formik.touched.additionalServices &&
                      Boolean(formik.errors.additionalServices)
                    }
                    InputProps={{
                      inputComponent: TextareaAutosize,
                      id: "additionalServices",
                      inputProps: {
                        style: {
                          resize: "none",
                          height: "60px",
                          overflow: "auto",
                        },
                      },
                    }}
                    className={classes.textArea}
                  />
                </Stack>
              </Grid>
            </Grid>
            {/**Business Hours */}

            <Grid container>
              <Grid item md={12}>
                <Typography variant="h1" className={globalClasses.typography}>
                  Business Hours
                </Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} md={12}>
                <Box className={classes.tabbackgroundcolor}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    aria-label="full width tabs example"
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Tab
                      className={classes.tabbackcolor}
                      label="Monday"
                      {...tabProps(0)}
                      sx={styles.tabClass}
                    />

                    <Tab
                      className={classes.tabbackcolor}
                      label="Tuesday"
                      {...tabProps(1)}
                      sx={styles.tabClass}
                    />
                    <Tab
                      className={classes.tabbackcolor}
                      label="Wednesday"
                      {...tabProps(2)}
                      sx={styles.tabClass}
                    />
                    <Tab
                      className={classes.tabbackcolor}
                      label="Thursday"
                      {...tabProps(3)}
                      sx={styles.tabClass}
                    />
                    <Tab
                      className={classes.tabbackcolor}
                      label="Friday"
                      {...tabProps(4)}
                      sx={styles.tabClass}
                    />
                    <Tab
                      className={classes.tabbackcolor}
                      label="Saturday"
                      {...tabProps(5)}
                      sx={styles.tabClass}
                    />
                    <Tab
                      className={classes.tabbackcolor}
                      label="Sunday"
                      {...tabProps(6)}
                      sx={styles.tabClass}
                    />
                  </Tabs>
                  {clinicDetailsObject.monday.map(
                    (monday: any, weekIndex: any) => {
                      /** This function is used to set default values to other tabs when you select checkbox
                                         of setAs default 
                                      */
                      const setTimeForWeek = (value: any) => {
                        SetTimeForWeekTab(formik, value, weekIndex, 0);
                      };
                      return (
                        <TabPanel key={weekIndex} value={value} index={0}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="Start Time"
                                value={
                                  formik.values.monday[weekIndex].startTime
                                }
                                name={`monday[${weekIndex}].startTime`}
                                id={`monday[${weekIndex}].startTime`}
                                inputValue={
                                  formik.values.monday[weekIndex].startTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `monday[${weekIndex}].startTime`,
                                    formik.values.monday[weekIndex].startTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `monday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `monday[${weekIndex}].startTime`
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="End Time"
                                value={formik.values.monday[weekIndex].endTime}
                                name={`monday[${weekIndex}].endTime`}
                                id={`monday[${weekIndex}].endTime`}
                                inputValue={
                                  formik.values.monday[weekIndex].endTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `monday[${weekIndex}].endTime`,
                                    formik.values.monday[weekIndex].endTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `monday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `monday[${weekIndex}].endTime`
                                )}
                              />
                            </Grid>
                            {
                              <Grid
                                item
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      id={`monday[${weekIndex}].setTimeAllWeek`}
                                      name={`monday[${weekIndex}].setTimeAllWeek`}
                                      value={
                                        formik.values.monday[weekIndex]
                                          .setTimeAllWeek
                                      }
                                      checked={
                                        formik.values.monday[weekIndex]
                                          .setTimeAllWeek
                                      }
                                    />
                                  }
                                  label="Set same time for all week"
                                  value={
                                    formik.values.monday[weekIndex]
                                      .setTimeAllWeek
                                  }
                                  onChange={(event: any, newValue: any) => {
                                    formik.setFieldValue(
                                      `monday[${weekIndex}].setTimeAllWeek`,
                                      newValue
                                    );

                                    setTimeForWeek(
                                      formik.values.monday[weekIndex]
                                    );
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                              </Grid>
                            }
                          </Grid>
                        </TabPanel>
                      );
                    }
                  )}
                  {clinicDetailsObject.tuesday.map(
                    (tuesday: any, weekIndex: any) => {
                      return (
                        <TabPanel key={weekIndex} value={value} index={1}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="Start Time"
                                value={
                                  formik.values.tuesday[weekIndex].startTime
                                }
                                name={`tuesday[${weekIndex}].startTime`}
                                id={`tuesday[${weekIndex}].startTime`}
                                inputValue={
                                  formik.values.tuesday[weekIndex].startTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].startTime`,
                                    formik.values.tuesday[weekIndex].startTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `tuesday[${weekIndex}].startTime`
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="End Time"
                                value={formik.values.tuesday[weekIndex].endTime}
                                name={`tuesday[${weekIndex}].endTime`}
                                id={`tuesday[${weekIndex}].endTime`}
                                inputValue={
                                  formik.values.tuesday[weekIndex].endTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].endTime`,
                                    formik.values.tuesday[weekIndex].endTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `tuesday[${weekIndex}].endTime`
                                )}
                              />
                            </Grid>
                          </Grid>
                        </TabPanel>
                      );
                    }
                  )}
                  {clinicDetailsObject.wednesday.map(
                    (wednesday: any, weekIndex: any) => {
                      return (
                        <TabPanel key={weekIndex} value={value} index={2}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="Start Time"
                                value={
                                  formik.values.wednesday[weekIndex].startTime
                                }
                                name={`wednesday[${weekIndex}].startTime`}
                                id={`wednesday[${weekIndex}].startTime`}
                                inputValue={
                                  formik.values.wednesday[weekIndex].startTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].startTime`,
                                    formik.values.wednesday[weekIndex].startTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `wednesday[${weekIndex}].startTime`
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="End Time"
                                value={
                                  formik.values.wednesday[weekIndex].endTime
                                }
                                name={`wednesday[${weekIndex}].endTime`}
                                id={`wednesday[${weekIndex}].endTime`}
                                inputValue={
                                  formik.values.wednesday[weekIndex].endTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].endTime`,
                                    formik.values.wednesday[weekIndex].endTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `wednesday[${weekIndex}].endTime`
                                )}
                              />
                            </Grid>
                          </Grid>
                        </TabPanel>
                      );
                    }
                  )}
                  {clinicDetailsObject.thursday.map(
                    (thursday: any, weekIndex: any) => {
                      return (
                        <TabPanel key={weekIndex} value={value} index={3}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="Start Time"
                                value={
                                  formik.values.thursday[weekIndex].startTime
                                }
                                name={`thursday[${weekIndex}].startTime`}
                                id={`thursday[${weekIndex}].startTime`}
                                inputValue={
                                  formik.values.thursday[weekIndex].startTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].startTime`,
                                    formik.values.thursday[weekIndex].startTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `thursday[${weekIndex}].startTime`
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="End Time"
                                value={
                                  formik.values.thursday[weekIndex].endTime
                                }
                                name={`thursday[${weekIndex}].endTime`}
                                id={`thursday[${weekIndex}].endTime`}
                                inputValue={
                                  formik.values.thursday[weekIndex].endTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].endTime`,
                                    formik.values.thursday[weekIndex].endTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `thursday[${weekIndex}].endTime`
                                )}
                              />
                            </Grid>
                          </Grid>
                        </TabPanel>
                      );
                    }
                  )}

                  {clinicDetailsObject.friday.map(
                    (friday: any, weekIndex: any) => {
                      return (
                        <TabPanel key={weekIndex} value={value} index={4}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="Start Time"
                                value={
                                  formik.values.friday[weekIndex].startTime
                                }
                                name={`friday[${weekIndex}].startTime`}
                                id={`friday[${weekIndex}].startTime`}
                                inputValue={
                                  formik.values.friday[weekIndex].startTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `friday[${weekIndex}].startTime`,
                                    formik.values.friday[weekIndex].startTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `friday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `friday[${weekIndex}].startTime`
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="End Time"
                                value={formik.values.friday[weekIndex].endTime}
                                name={`friday[${weekIndex}].endTime`}
                                id={`friday[${weekIndex}].endTime`}
                                inputValue={
                                  formik.values.friday[weekIndex].endTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `friday[${weekIndex}].endTime`,
                                    formik.values.friday[weekIndex].endTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `friday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `friday[${weekIndex}].endTime`
                                )}
                              />
                            </Grid>
                          </Grid>
                        </TabPanel>
                      );
                    }
                  )}
                  {clinicDetailsObject.saturday.map(
                    (saturday: any, weekIndex: any) => {
                      return (
                        <TabPanel key={weekIndex} value={value} index={5}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="Start Time"
                                value={
                                  formik.values.saturday[weekIndex].startTime
                                }
                                name={`saturday[${weekIndex}].startTime`}
                                id={`saturday[${weekIndex}].startTime`}
                                inputValue={
                                  formik.values.saturday[weekIndex].startTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].startTime`,
                                    formik.values.saturday[weekIndex].startTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `saturday[${weekIndex}].startTime`
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="End Time"
                                value={
                                  formik.values.saturday[weekIndex].endTime
                                }
                                name={`saturday[${weekIndex}].endTime`}
                                id={`saturday[${weekIndex}].endTime`}
                                inputValue={
                                  formik.values.saturday[weekIndex].endTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].endTime`,
                                    formik.values.saturday[weekIndex].endTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `saturday[${weekIndex}].endTime`
                                )}
                              />
                            </Grid>
                          </Grid>
                        </TabPanel>
                      );
                    }
                  )}
                  {clinicDetailsObject.sunday.map(
                    (sunday: any, weekIndex: any) => {
                      return (
                        <TabPanel key={weekIndex} value={value} index={6}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="Start Time"
                                value={
                                  formik.values.sunday[weekIndex].startTime
                                }
                                name={`sunday[${weekIndex}].startTime`}
                                id={`sunday[${weekIndex}].startTime`}
                                inputValue={
                                  formik.values.sunday[weekIndex].startTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `sunday[${weekIndex}].startTime`,
                                    formik.values.sunday[weekIndex].startTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `sunday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `sunday[${weekIndex}].startTime`
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <TimeComponent
                                label="End Time"
                                value={formik.values.sunday[weekIndex].endTime}
                                name={`sunday[${weekIndex}].endTime`}
                                id={`sunday[${weekIndex}].endTime`}
                                inputValue={
                                  formik.values.sunday[weekIndex].endTime
                                }
                                onChange={() => {
                                  formik.setFieldValue(
                                    `sunday[${weekIndex}].endTime`,
                                    formik.values.sunday[weekIndex].endTime
                                  );
                                }}
                                inputOnChange={formik.handleChange}
                                inputOnBlur={formik.handleBlur}
                                onAccept={(newValue: Date | null) => {
                                  formik.setFieldValue(
                                    `sunday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                }}
                                error={getIn(
                                  formik.errors,
                                  `sunday[${weekIndex}].endTime`
                                )}
                              />
                            </Grid>
                          </Grid>
                        </TabPanel>
                      );
                    }
                  )}
                </Box>
              </Grid>
            </Grid>

            {mode !== "edit" && (
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "15px",
                  marginTop: "20px",
                }}
              >
                {isUpdate ? (
                  <ButtonComponent
                    buttonclass={globalClasses.addAnotherServiceGreen}
                    variant="contained"
                    size="small"
                    onClick={(event: any) => {
                      updateService();
                      setValue(0);
                      event.preventDefault();
                    }}
                    disable={disableButton}
                    label="Update"
                  />
                ) : (
                  <form>
                    <ButtonComponent
                      buttonclass={globalClasses.addAnotherServiceGreen}
                      variant="contained"
                      size="small"
                      onClick={async (event: any) => {
                        addService();
                        setValue(0);
                        event.preventDefault();
                      }}
                      disable={disableButton}
                      label="Add Clinic"
                    />
                  </form>
                )}
              </Grid>
            )}
          </CommonCard>
        </Box>
        <ServiceTable
          getData={data}
          setData={handleEdit}
          isLoading={async () => {
            await setOpen(true);
          }}
          deleteService={handleDelete}
        />

        {mode !== "edit" && (
          <Grid container spacing={2} direction="row">
            <Grid item xs={12} md={12}>
              <form>
                <ButtonComponent
                  variant="contained"
                  size="small"
                  type="submit"
                  buttonclass={classes.nextButton}
                  onClick={(event: any) => {
                    console.log("hello");
                    sendClinicData(data);
                    event.preventDefault();
                  }}
                  label="Next"
                  disable={disableRegister}
                />
              </form>
            </Grid>
          </Grid>
        )}

        {mode === "edit" && (
          <Grid container spacing={2} direction="row">
            <Grid item xs={12} md={12}>
              <form>
                <ButtonComponent
                  variant="contained"
                  size="small"
                  type="submit"
                  buttonclass={classes.nextButton}
                  onClick={(event: any) => {
                    event.preventDefault();
                    formik.handleSubmit(event);
                  }}
                  buttontitle="Save"
                  label="Save"
                />
              </form>
            </Grid>
          </Grid>
        )}
      </FormikProvider>

      {(open || disableButton) && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          <Typography fontWeight="600" fontSize="20px">
            Loading Clinic Information...!
          </Typography>
          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}
    </Fragment>
  );
};

export default ServiceDetails;
